/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useContext, useEffect } from 'react'
import './styles.scss'

import {
  ControlProps,
  RankedTester,
  rankWith,
  and,
  schemaMatches,
  isObjectControl
} from '@jsonforms/core'

import { useJsonForms, withJsonFormsControlProps } from '@jsonforms/react'
import { JsonFormCustomContext } from '../../QuestionnareForm'
import { get } from 'lodash'

const DEFAULT_DATA = {
  isEnabled: true,
  isRequired: true,
  isCompleted: false
}

export const Enabler = (props: ControlProps) => {
  const { label, handleChange, data, path, schema, visible, uischema } = props
  const jsonFormCustomContextInstance = useContext(JsonFormCustomContext)
  const fetchNestedSchemaEmitter =
    jsonFormCustomContextInstance?.fetchNestedSchema
  const removeNestedDataEmitter =
    jsonFormCustomContextInstance?.removeNestedDataHandler
  const jsonFormsContext = useJsonForms()

  const { core } = jsonFormsContext
  const getClassName = () => {
    return 'custom-div'
  }

  function getArrayIndexFromPath() {
    let arrIndex: number | undefined
    const arr = path.split('.')

    for (let i = arr.length - 1; i >= 0; i--) {
      const current = arr[i]
      if (typeof current === 'number' && !isNaN(current)) {
        arrIndex = current
        break
      }
      if (typeof current === 'string' && !isNaN(Number(current))) {
        arrIndex = Number(current)
        break
      }
    }

    return arrIndex
  }

  function getIdFromEntries() {
    const pathArr = path.split('.')

    return core?.data[pathArr[0]][pathArr[1]]['id']
  }

  function getCurrentDataArrayPath() {
    const pathParts = path.split('.')
    const resultParts = []

    for (const part of pathParts) {
      if (isNaN(parseInt(part))) {
        resultParts.push(part)
      } else {
        resultParts.push(part)
        break
      }
    }

    return resultParts.join('.')
  }

  function getNextDataPath() {
    const splittedPath = path.split('.')
    const navigation_name = splittedPath[splittedPath.length - 1]

    const propertyName = navigation_name.replace('navigation_', '')
    return path.replace(navigation_name, '') + propertyName
  }

  function getNextFormData() {
    const nextDataPath = getNextDataPath()
    return get(core?.data, nextDataPath)
  }

  function handleClickAndEmit(path: string) {
    const id = getIdFromEntries()
    const nextData = getNextFormData()
    const arrayIndex = getArrayIndexFromPath()
    const currentDataArrayPath = getCurrentDataArrayPath()
    if (fetchNestedSchemaEmitter) {
      fetchNestedSchemaEmitter(
        (schema as any).nextSchema,
        getNextDataPath(),
        nextData,
        id,
        arrayIndex,
        currentDataArrayPath
      )
    }
  }

  function getStatusIcon() {
    if (data && data?.isCompleted) {
      return 'mdi mdi-check-circle-outline success'
    }
    return 'mdi mdi-check-circle-outline'
  }

  useEffect(() => {
    if (visible) {
      if (!data) {
        let defaultData = DEFAULT_DATA
        if ((schema as any).isDisabled) {
          defaultData = { ...defaultData, isCompleted: true }
        }
        handleChange(path, defaultData)
      } else {
        const defaultData = DEFAULT_DATA
        if (data && data.isRequired === false) {
          handleChange(path, defaultData)
        }
        if (data && (schema as any).isDisabled && data.isCompleted === false) {
          handleChange(path, { ...defaultData, isCompleted: true })
        }
      }
    }

    if (!visible) {
      const defaultData = {
        ...DEFAULT_DATA,
        isEnabled: false,
        isRequired: false,
        isCompleted: true
      }
      handleChange(path, defaultData)
      if (removeNestedDataEmitter) {
        if (get(core?.data, getNextDataPath())) {
          removeNestedDataEmitter(getNextDataPath())
        }
      }
    }
  }, [visible, data])

  return (
    <>
      {visible && !(schema as any).isDisabled && (
        <div className='form-group'>
          <div
            className={getClassName()}
            style={{
              width: '100%',
              height: '40px',
              border: '1px solid #D1D6D7',
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
              cursor: 'pointer',
              padding: '0.5rem'
            }}
            onClick={() => handleClickAndEmit(path)}
            data-testid='custom-navigation-div'
          >
            {data && data?.isCompleted ? (
              <span
                className={getStatusIcon()}
                style={{
                  flexBasis: 'calc(6%)',
                  fontSize: '25px',
                  display: 'flex',
                  justifyContent: 'flex-start',
                  marginTop: '1px'
                }}
                data-testid='completed-icon'
              />
            ) : (
              <span
                className='mdi mdi-check-circle-outline'
                style={{
                  flexBasis: 'calc(6%)',
                  fontSize: '25px',
                  display: 'flex',
                  justifyContent: 'flex-start',
                  color: '#D1D6D7',
                  marginTop: '1px'
                }}
              />
            )}
            <span
              className='navigation-inner-item'
              style={{
                flexGrow: 1,
                display: 'flex',
                color: '#173237',
                paddingTop: '1px',
                marginLeft: '5px'
              }}
            >
              <span
                style={{ marginLeft: 0 }}
                data-testid='enabler-label'
              ></span>
              {label}
            </span>
            {!data?.isCompleted &&
            core?.validationMode === 'ValidateAndShow' ? (
              <span
                className='mdi mdi-alert-rhombus-outline'
                style={{
                  flexBasis: 'calc(10% - 10px)',
                  fontSize: '20px',
                  color: '#E12339',
                  display: 'inline-block'
                }}
                data-testid='error-icon'
              ></span>
            ) : (
              <></>
            )}
            <span
              className='mdi mdi-chevron-right'
              style={{
                flexBasis: 'calc(10% - 40px)',
                fontSize: '20px',
                color: '#173237',
                display: 'inline-block'
              }}
              data-testid='right-icon'
            />
          </div>
          {!data?.isCompleted && core?.validationMode === 'ValidateAndShow' ? (
            <div className='text-danger' style={{ marginTop: '0.5rem' }}>
              <span>{`Please ${(label as string).toLowerCase()}`}</span>
            </div>
          ) : (
            <></>
          )}
        </div>
      )}
    </>
  )
}

export const enablerTester: RankedTester = rankWith(
  101, //increase rank as needed
  and(
    isObjectControl,
    schemaMatches((schema: { hasOwnProperty: (arg0: string) => any }) =>
      // eslint-disable-next-line no-prototype-builtins
      schema.hasOwnProperty('isCustomEnabler')
    )
  )
)

export const EnablerControl = withJsonFormsControlProps(Enabler)
